/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ReorderPraetorPolicyPlansBody = zod
	.object({
		policy_plan_ids: zod.array(zod.uuid()).describe('Ordered list of policy plan IDs')
	})
	.describe('Request body for reordering policy plan components');

export type ReorderPraetorPolicyPlansBody = zod.input<typeof ReorderPraetorPolicyPlansBody>;
export type ReorderPraetorPolicyPlansBodyOutput = zod.output<typeof ReorderPraetorPolicyPlansBody>;
